import { CheckCircle2, Loader2 } from "lucide-react";

const STEPS = [
  { key: "researching", label: "Researching (live Tavily sources)" },
  { key: "scoring", label: "Scoring 20 criteria" },
  { key: "teardown", label: "Writing 7-section teardown" },
  { key: "scripts", label: "Discovery scripts & names" },
  { key: "done", label: "Done" },
];

export const EvaluationProgress = ({ progress }) => {
  const idx = Math.max(0, STEPS.findIndex((s) => s.key === progress.progress_stage));
  const queued = ["queued", "retrying", null, undefined].includes(progress.progress_stage);
  return (
    <section className="iv-glass rounded-2xl p-5" role="status" aria-live="polite" data-testid="evaluation-progress" data-stage={progress.progress_stage || "queued"}>
      <p className="text-sm font-bold text-white">{queued ? (progress.progress_stage === "retrying" ? "Retrying after a hiccup…" : "Queued — starting shortly…") : "Your 20-criteria validation is running"}</p>
      <p className="mt-1 text-xs text-slate-400">Usually 1–3 minutes. You can keep browsing; this page updates automatically.</p>
      <ol className="mt-4 grid gap-2 sm:grid-cols-5">
        {STEPS.map((s, i) => {
          const done = !queued && i < idx;
          const active = !queued && i === idx;
          return (
            <li key={s.key} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-xs ${active ? "border-cyan-400/60 text-cyan-200" : done ? "border-emerald-400/40 text-emerald-300" : "border-white/[0.06] text-slate-500"}`} data-testid={`progress-step-${s.key}`}>
              {done ? <CheckCircle2 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" /> : active ? <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden="true" /> : <span className="h-3.5 w-3.5 shrink-0 rounded-full border border-current" aria-hidden="true" />}
              {s.label}
            </li>
          );
        })}
      </ol>
    </section>
  );
};
